<template>
    <div>
        <div  class="md-layout" id="crops-section">
            <crops-menu :regions="regions"
                        :crops="crops"
                        :regionSelected="regionSelected"
                        :cropSelected="cropSelected"
                        :info="info"
                        @update-selected-region="updateSelectedRegion"
                        @update-selected-crop="updateSelectedCrop"/>
            <div v-if="hasData" class="md-layout">
                <div class="md-layout-item md-size-30 mt20 md-small-size-50 md-xsmall-size-100">
                    <data-card :data="dataRow" />
                </div>
                <div class="md-layout-item md-size-30 crops-graph-card md-small-size-50 md-xsmall-size-100">
                    <graph-card v-if="ready" :data='dataRow' :headers='headers' />
                </div>
                <div class="md-layout-item md-size-20 md-small-size-50 md-xsmall-size-50 gauge-container">
                    <gauge-card type='price' :data='dataRow' :infoMessage="info[4]"/>
                </div>
                <div class="md-layout-item md-size-20 md-small-size-50 md-xsmall-size-50 gauge-container">
                    <gauge-card type='render' :data='dataRow' :infoMessage="info[5]"/>
                </div>
                <div class="md-layout-item md-size-100 " style="margin-top:-30px">
                    <tabs
                        :tab-name="['Margen Bruto', 'Margen Neto', 'Sensibilidad renta', 'Costos Comerciales', 'Costos Producción', 'Etapa de cultivo', 'Clima']"
                        flex-column
                        class="az-tabs"
                        color-button="success">
                        <template slot="tab-pane-1">
                            <gross-margin v-if="ready" :data='dataRow' :headers="headers"/>
                        </template>
                        <template slot="tab-pane-2">
                            <net-margin v-if="ready" :data='dataRow' :headers="headers" />
                        </template>
                        <template slot="tab-pane-3">
                            <sensibility v-if="ready" :data='dataRow' />
                        </template>
                        <template slot="tab-pane-4">
                            <commercial-cost v-if="ready" :data='dataRow'/>
                        </template>
                        <template slot="tab-pane-5">
                            <production-cost v-if="ready" :data='dataRow' />
                        </template>
                        <template slot="tab-pane-6">
                            <img :src="'/img/'+getCropEvolutionClassCrop+'/'+getCropEvolutionClassCrop+'.'+getCropEvolutionClassStage+'.jpg'">

                        </template>
                        <template slot="tab-pane-7" >
                            <img class="crops-weather" :src="dataRow['clima']">
                        </template>
                    </tabs>
                </div>
            </div>
            <div v-else class="md-layout" >
                <div class="md-layout-item  md-size-100 no-data">
                    No hay datos disponibles
                </div>
            </div>
        </div>

         <modal @close="closeModal" v-if="displayModal" class="advertising-modal">
            <template slot="body">
                <img :src="adv[5]" style="max-height: 500px">
            </template>
            <template slot="footer">
                <md-button class="md-danger md-simple" @click="closeModal">Cerrar</md-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Tabs from '@/components/Tabs'
import DataCard from '@/components/Crops/DataCard'
import GraphCard from '@/components/Crops/GraphCard'
import GrossMargin from '@/components/Crops/GrossMargin'
import NetMargin from '@/components/Crops/NetMargin'
import Sensibility from '@/components/Graphs/Sensibility'
import CommercialCost from '@/components/Graphs/CommercialCost'
import ProductionCost from '@/components/Graphs/ProductionCost'
import Modal from '@/components/Modal'
import GaugeCard from '@/components/Crops/GaugeCard'
import CropsMenu from '@/components/Crops/Menu'


export default {
  data ()  {
    return {
      regionSelected: '',
      cropSelected: '',
      displayModal: false,
      dataRow: [],
      ready: false,
      hasData: true,
      stage: 1
    }
  },
  components: {
    DataCard,
    GraphCard,
    Tabs,
    GrossMargin,
    NetMargin,
    Sensibility,
    CommercialCost,
    ProductionCost,
    Modal,
    GaugeCard,
    CropsMenu
  },
  computed: {
    ...mapState(['regions','crops','headers','info','adv']),
    getCropEvolutionClassCrop() {
      switch(this.cropSelected.trim()){
      case 'Soja': return 'soja';
      case 'Maíz': return 'maiz';
      case 'Girasol': return 'girasol';
      default: return 'trigo';
      }

    },
    getCropEvolutionClassStage() {
      switch(this.stage){
      case 1: return 'one';
      case 2: return 'two';
      case 3: return 'three';
      case 4: return 'four';
      case 5: return 'five';
      case 6: return 'six';
      case 7: return 'seven';
      case 8: return 'eight';
      default: return 'one';
      }
    },
    currentCropImg() {
      switch(this.cropSelected.trim()){
      case 'Soja': return 'soja.jpg';
      case 'Maíz': return 'girasol.jpg';
      case 'Girasol': return 'maiz.jpg';
      default: return 'trigo.jpg';
      }
    }
  },
  watch: {
    regionSelected: function() {
      this.loadData();

    },
    cropSelected: function() {
      this.loadData();
    }
  },
  methods: {
    ...mapActions(['getDataRow']),

    updateSelectedRegion(region) {
      this.regionSelected = region;
    },
    updateSelectedCrop(crop) {
      this.cropSelected = crop;
    },
    closeModal() {
      this.displayModal= false;
    },
    checkIfHasData()  {
      if (this.dataRow['renta'] == '-')
        this.hasData = false;
      else
        this.hasData = true;
    },
    loadData() {
      this.ready = false;
      this.getDataRow({cropSelected: this.cropSelected, regionSelected: this.regionSelected})
        .then(response => {
          this.dataRow = response;
          this.ready = true;
          this.checkIfHasData();
          this.stage = this.dataRow['etapa_cultivo'];

        });
    }

  },
  mounted() {

    this.regionSelected = this.regions[0];
    this.cropSelected = this.crops[0];
    this.ready = true
    //setTimeout(() => { this.displayModal = true; }, 3000);
  },

}
</script>
<style>
.advertising-modal .modal-body, .advertising-modal .modal-header, .advertising-modal .modal-footer{
    padding: 0px;
}
.no-data{
    text-align: center;
    margin-top: 250px;
    font-size: 52px;
    font-weight: bold;
    color: #667;
}
.mt5{
    margin-top:6px
}
.crops-graph-card {
  margin-top: 50px;
}
.advertising-modal .modal-container{
    max-width: 600px
}
.gauge-container{
  padding-top:10px;
  margin-top: 50px;
}

#crops-section .echarts {
  height: 300px;
  width: 100%;
}
.az-tabs .md-card-header{
    padding: 5px
}
.az-tabs .md-list-item-button{
    line-height: 1.3em !important;
}
.category{
    color:#333 !important
}
.md-card.md-card-chart .md-card-header:not(.md-card-header-icon):not(.md-card-header-text){
    min-height: 60px;
}

.crops-weather{
  width:600px;

}

@media only screen and (max-width: 960px) {
  .gauge-container{
    padding-top:0px;
    margin-top: 0px;
  }
  .md-small-size-hide{
    display: none;
  }
  .crops-weather{
    margin-left: 0;
  }
}
@media only screen and (max-width: 760px) {
  .az-tabs .md-list-item-button{
    font-size: 10px !important;
  }

}

@media only screen and (max-width: 600px) {
  .crops-graph-card {
    margin-top: 0;
  }


}



</style>
